module.exports = __webpack_public_path__ + "static/media/sy.ff41b6a2.svg";